import React from "react"
import Header4 from "./../Common/Header4"
import Footer2 from "./../Common/Footer2"
import Slider6 from "./../Elements/Slider6"
import WhatWeDo1 from "./../Elements/WhatWeDo3"
import Projects3 from "./../Elements/Projects3"
// import SimilarProjects from "./../Elements/SimilarProjects"
import Services3 from "./../Elements/Services3"
import ClientsLogo2 from "./../Elements/ClientsLogo2"
import About4 from "../Elements/About4"

class Home6 extends React.Component {
  render() {
    return (
      <>
        <Header4 />
        <div className="page-content">
          <Slider6 />
          <About4 />
          <Services3 />
          <WhatWeDo1 />
          <Projects3 />
          {/* <SimilarProjects
            alignment="separator-center"
            // title="Similar Project"
            title="We Are Reliable"
          /> */}
          {/* <ClientsLogo2 bgcolor="bg-white" /> */}
        </div>

        <Footer2 />
      </>
    )
  }
}

export default Home6
